angular.module('admin.directives')

.directive('agentSelector', ['AgentService', function(AgentService){
  return {
    controllerAs: 'agentSelectorCtrl',
    bindToController: { },
    scope: { },
    restrict: 'A',
    template: `
    <option value="">Select...</option>
    <option ng-repeat="agent in agentSelectorCtrl.agents | orderBy : 'last_name'" value="{{agent.id}}" track-by="agent.id">
    {{agent.last_name}}, {{agent.first_name}}
    </option>
    `,
    controller: function(){
      let ctrl = this;

      AgentService.getAll({filter:{where:{type:'mortgage'}}})
        .then((agents) => {
          ctrl.agents = agents;
        })
        .catch((e) => {
          console.error('Error retrieving all agents', e);
        });
    }
  }
}]);
